var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 47 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__a)",
    d: "M32.61 6.98a.7.7 0 0 0-.61.363l-3.96 7.253-4.574 8.375a.696.696 0 0 1-1.221 0l-4.574-8.375-3.961-7.253a.7.7 0 0 0-.61-.362H1.204c-.536 0-.87.58-.603 1.043l10.9 18.88 10.9 18.88a.695.695 0 0 0 1.206 0l10.9-18.88 10.9-18.88a.695.695 0 0 0-.603-1.043z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__b)",
    d: "M32.61 6.98a.7.7 0 0 0-.61.363l-3.96 7.253-4.574 8.375a.696.696 0 0 1-1.221 0l-4.574-8.375-3.961-7.253a.7.7 0 0 0-.61-.362H1.204c-.536 0-.87.58-.603 1.043l.344.595c2.218 2.906 5.51 7.375 8.89 12.094l3.334 4.657c5.41 7.553 14.261 7.553 19.67 0l3.336-4.657c2.949-4.118 5.938-8.094 8.271-11.039a1 1 0 0 0 .057-.083l.904-1.567a.695.695 0 0 0-.602-1.043z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__c)",
    d: "M23.49 20.582a.695.695 0 0 1-1.22 0l-4.061-7.437-4.11-7.524a.695.695 0 0 1 .61-1.03h16.342c.528 0 .864.566.61 1.03l-4.11 7.524z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__d)",
    d: "M14.617 4.892a.348.348 0 0 0-.203.63l3.17 2.278a9.08 9.08 0 0 0 10.592 0l3.17-2.278a.348.348 0 0 0-.203-.63H14.618"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 23.005,
    x2: 23.005,
    y1: 6.981,
    y2: 46.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0644D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 23.022,
    x2: 23.022,
    y1: -2.613,
    y2: 27.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0644D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 22.893,
    x2: 22.88,
    y1: -7.851,
    y2: 21.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0644D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 22.893,
    x2: 22.88,
    y1: -0.049,
    y2: 9.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0644D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })))));
};
export default SvgLogo;